export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const checked = require("../assets/checked.png");
export const plus = require("../assets/plus.png");
export const favourites = require("../assets/favourites.png");
export const noPitch = require("../assets/noPitch.png");
export const notFavourites = require("../assets/notFavourites.png");
export const offlineIndicator = require("../assets/offlineIndicator.png");
export const onlineIndicator = require("../assets/onlineIndicator.png");
export const pitch = require("../assets/pitch.png");
export const chat = require("../assets/chat.png");
export const block = require("../assets/block.png");
export const share = require("../assets/share.png");
